import React from "react";
import { PropTypes } from 'prop-types';
import { Form } from "antd";
import { EmailTitleWrapperFont } from "../styles";
import moment from "moment";
import { DOBWrap } from "./styles";
import { MarginSpecific } from "./styles";
import { FormItemWrapper } from "../../Step1Setup/styles";
import Calendar from '../../../../../CommonComponents/Calendar/Calendar';

const DatePickerComponent = props => {
  const { getFieldDecorator } = props.form;
  function disabledDate(current) {
    // Can not select days before today and today
    return current && current > moment().endOf("day");
  }
  return (
    <div>
      <FormItemWrapper
        colon={false}
        label={
          <MarginSpecific paddingTop="2px">
            <EmailTitleWrapperFont>{props.title}</EmailTitleWrapperFont>
          </MarginSpecific>
        }
      >
        {getFieldDecorator("dob"+props.id, {
          rules: [
            {
              type: "string"
            }
          ]
        })(
          <DOBWrap height="22px">
            <Calendar
              id={props.id}
              onBlur={ (e) => props.handleBlur ? props.handleBlur(e): ''}
              allowClear={false}
              placeHolder={props.placeholder}
              format="MM/DD/YYYY"
              disabledDate={disabledDate}
              onChange={ (e) => props.handleInputChange ? props.handleInputChange(e): ''}
              value={
                props.value ? moment(props.value, "MM/DD/YYYY") : undefined
              }
            />
          </DOBWrap>
        )}
      </FormItemWrapper>
    </div>
  );
};

const WrappedDOBComponent = Form.create({ name: "dob" })(DatePickerComponent);

DatePickerComponent.propTypes = {
  form: PropTypes.object,
  handleBlur: PropTypes.func,
  handleInputChange: PropTypes.func,
  id: PropTypes.string,
  placeholder: PropTypes.string,
  title: PropTypes.string,
  value: PropTypes.string,
}

export default WrappedDOBComponent;
